// extracted by mini-css-extract-plugin
module.exports = {"contenfulValidationErrorMessage":"ContentfulForm_contenfulValidationErrorMessage__2Q-gt"};